export const getWeeklyPerformanceText = (value: number | undefined) => {
  if (value === undefined) {
    return '';
  }

  if (value > 0) {
    return 'Höher als letzte Woche';
  }

  if (value < 0) {
    return 'Tiefer als letzte Woche';
  }

  return 'Gleich wie letzte Woche';
};

export const getWeeklyPerformanceColor = (value: number | undefined) => {
  if (value === undefined) {
    return {};
  }

  if (value >= 0) {
    return {
      valuePercentageColor: 'success.dark',
      valuePercentageBackgroundColor: 'success.light',
      valuePercentageBorderColor: 'success.main',
    };
  }

  return {
    valuePercentageColor: 'warning.dark',
    valuePercentageBackgroundColor: 'warning.light',
    valuePercentageBorderColor: 'warning.main',
  };
};

export const getWeeklyPerformanceEffectiveRateText = (value: number | undefined) => {
  if (value === undefined) {
    return '';
  }

  if (value > 0) {
    return 'Teurer als letzte Woche';
  }

  if (value < 0) {
    return 'Günstiger als letzte Woche';
  }

  return 'Gleich wie letzte Woche';
};

export const getWeeklyPerformanceEffectiveRateColor = (value: number | undefined) => {
  if (value === undefined) {
    return {};
  }

  if (value <= 0) {
    return {
      valuePercentageColor: 'success.dark',
      valuePercentageBackgroundColor: 'success.light',
      valuePercentageBorderColor: 'success.main',
    };
  }

  return {
    valuePercentageColor: 'warning.dark',
    valuePercentageBackgroundColor: 'warning.light',
    valuePercentageBorderColor: 'warning.main',
  };
};
